var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.235,
    height: 18.823,
    viewBox: "0 0 28.235 18.823",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-eye",
    "data-name": "Icon awesome-eye",
    d: "M28.065,13.2A15.722,15.722,0,0,0,14.118,4.5,15.725,15.725,0,0,0,.171,13.2a1.586,1.586,0,0,0,0,1.431,15.722,15.722,0,0,0,13.947,8.7,15.725,15.725,0,0,0,13.947-8.7A1.586,1.586,0,0,0,28.065,13.2ZM14.118,20.971a7.059,7.059,0,1,1,7.059-7.059A7.059,7.059,0,0,1,14.118,20.971Zm0-11.765a4.672,4.672,0,0,0-1.241.186A2.346,2.346,0,0,1,9.6,12.671a4.7,4.7,0,1,0,4.52-3.465Z",
    transform: "translate(0 -4.5)",
    fill: "#bcbcbc"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.f63610fc38742c1fd54f9cd3966040d4.svg";
export { ForwardRef as ReactComponent };